jQuery( function($){

    $('.js-accordion').each(function(){
        var $accordion = $(this);
        var $btn_active = $accordion.find('.js-accordion__btn.active');
        var $btn_active_content = $btn_active.next('.js-accordion__content');
        var $allBtns = $accordion.find('.js-accordion__btn');

        $btn_active_content.slideDown(400);
        // $btn_active.addClass('active');

        $allBtns.click(function () {
            var $this_btn = $(this);
            var $this_item = $this_btn.closest('.js-accordion__item');
            var $this_content = $this_item.find('.js-accordion__content');
            var $othersItems = $this_item.siblings();
            var $othersBtns = $othersItems.find('.js-accordion__btn');
            var $othersContents = $othersItems.find('.js-accordion__content');

            // Always one open
            $this_btn.addClass('active');
            $this_content.slideDown(400);
            $othersBtns.removeClass('active');
            $othersContents.slideUp(400);
        });
    });

});
